Input containing candidates and optional position context.
